function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.5,
    height: 16.2,
    viewBox: "0 0 13.5 16.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon feather-trash-2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6362",
    d: "M4.5 9H18",
    transform: "translate(-4.5 -5.4)",
    style: {
      fill: "none",
      stroke: "#29302e",
      strokeLinejoin: "round",
      strokeWidth: "1.2px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6363",
    d: "M18 6v10.5a1.5 1.5 0 0 1-1.5 1.5H9a1.5 1.5 0 0 1-1.5-1.5V6m2.25 0V4.5a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5V6",
    transform: "translate(-6 -2.4)",
    style: {
      fill: "none",
      stroke: "#29302e",
      strokeLinejoin: "round",
      strokeWidth: "1.2px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6364",
    d: "M15 16.5V21",
    transform: "translate(-9.75 -9.15)",
    style: {
      fill: "none",
      stroke: "#29302e",
      strokeLinejoin: "round",
      strokeWidth: "1.2px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6365",
    d: "M21 16.5V21",
    transform: "translate(-12.75 -9.15)",
    style: {
      fill: "none",
      stroke: "#29302e",
      strokeLinejoin: "round",
      strokeWidth: "1.2px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownTrash);
export default __webpack_public_path__ + "static/media/dropdownTrash.8d04819a8bc89823984309e543baa6c2.svg";
export { ForwardRef as ReactComponent };